<template>
  <div>
    <el-select
      :style="styles"
      v-model="val"
      filterable
      :multiple="multiple"
      :placeholder="placeholder"
      clearable
      @change="handlerChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
  import { IDCardTypes } from './enum.id-card-type'
  import { transFormDataType } from '../utils'
  export default {
    name: 'ComIdCardTypeSelector',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      // 是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择证件类型'
      },
      styles: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        val: undefined
      }
    },
    computed: {
      options() {
        return IDCardTypes
      }
    },
    watch: {
      val: {
        handler(newVal, oldVal) {
          if (newVal === oldVal) {
            return
          }
          this.emitInput()
        }
      },
      value: {
        handler(newVal, oldVal) {
          if (newVal === this.val) {
            return
          }
          this.val = transFormDataType(newVal)
        },
        immediate: true
      }
    },
    methods: {
      emitInput() {
        const v = this.val
        this.$emit('input', v)
      },
      handlerChange(id) {
        if (this.multiple) {
          this.$emit('change', id)
          return
        }
        const item = this.options.find((item) => id === item.value)
        this.$emit('change', item)
      }
    }
  }
</script>

<style lang="scss" scoped></style>
